import { render, staticRenderFns } from "./paginate-links-count.vue?vue&type=template&id=523a3fbb"
import script from "./paginate-links-count.vue?vue&type=script&lang=js"
export * from "./paginate-links-count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports